import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';
import { Icon } from 'signoxe/components/widgets';
import { selectUploadFiles, startUploadFile } from 'signoxe/actions'
import { connect } from 'react-redux';
import './styles.scss';

import getOptions from 'signoxe/utils/tusOptions'
var tus = require("tus-js-client");

const MIN = 0
const MAX = 1024 * 1024 * 1000

class AssetResumable extends React.Component{
  constructor(props){
    super(props);
    this.handleDrop = this.handleDrop.bind(this)
  }

  static propTypes = {
    onDrop: PropTypes.func.isRequired,
    selectUploadFiles: PropTypes.func.isRequired,
    startUploadFile: PropTypes.func.isRequired
  };

  handleDrop(files){
    files.forEach((file) => {
      // console.log(file, tus)
      let upload = new tus.Upload(file, getOptions('sdsds', file))
      upload.findPreviousUploads().then((previousUploads) => {
        if (previousUploads.length !== 0){
          // Give user the option of choosing among new files
          // Dispatch to component handler which shows a choice type, then onselect.
          this.props.selectUploadFiles({metadata: previousUploads[0], file})
        }
        else{
          // Start a new upload for a seperate file
          // Dispatch to the component handler which for new files
          // console.log(this.props)
          this.props.startUploadFile({file})
        }
      });
    })

  }


  render(){
    return <Dropzone minSize={MIN} maxSize={MAX} multiple={false} onDrop={this.handleDrop}
              accept={this.props.accept}
              className="asset-upload"
              activeClassName="asset-upload active">
      <div className="show-for-large">
        {this.props.instruction}
      </div>
      <div className="small show-for-large">
        Supported image types are <em>PNG</em> and <em>JPEG</em>,&nbsp;
        and supported video formats are <em>MP4</em> and <em>WEBM</em>.
        <h6><b>With Resumable Uploads you can always resume uploads by re-uploading the same file using this box</b>.</h6>
      </div>
      <div className="hide-for-large button large">
        <Icon name="upload" color="white"/>
        Resumable Uploads</div>
    </Dropzone>
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  startUploadFile, selectUploadFiles
})(AssetResumable)



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetResumable/index.js